<template>
  <section>
    <h3>
      <TextHeading variant="md" semi>Select a report year</TextHeading>
    </h3>
    <div class="filter">
      <button class="filter__button-back">
        <BaseIcon name="chevron_left" size="24"></BaseIcon>
      </button>
      <button class="filter__button active">2018/19</button>
      <button class="filter__button">2017/18</button>
      <button class="filter__button">2016/17</button>
      <button class="filter__button">2015/16</button>
      <button class="filter__button">2014/15</button>
      <button class="filter__button">2013/14</button>
      <button class="filter__button">2012/13</button>
      <button class="filter__button">2011/12</button>
      <button class="filter__button">2010/11</button>
      <button class="filter__button-forward">
        <BaseIcon name="chevron_right" size="24"></BaseIcon>
      </button>
    </div>
  </section>
</template>

<script>
import BaseIcon from '../elements/BaseIcon.vue'
import TextHeading from '../elements/TextHeading.vue'
export default { name: 'TheFilter', components: { TextHeading, BaseIcon } }
</script>

<style lang="postcss">
.filter {
  @apply border border-t-0 border-l-0 border-r-0 border-body-lighter relative px-2 flex overflow-x-scroll mb-8;
}
.filter__button {
  @apply bg-white text-black font-semibold px-2 py-4 mx-2;
}
.filter__button.active {
  @apply border-4 border-t-0 border-l-0 border-r-0 border-secondary text-secondary;
}
.filter__button:hover,
.filter__button-back:hover,
.filter__button-forward:hover {
  @apply text-secondary;
}
.filter__button:focus,
.filter__button-back:focus,
.filter__button-forward:focus {
  @apply outline-none;
}
.filter__button-back {
  @apply left-0 hidden;
}
.filter__button-forward {
  @apply right-0 hidden;
}
@screen md {
  .filter {
    @apply overflow-hidden mb-12;
  }
  .filter__button {
    @apply mx-4;
  }
  .filter__button-back,
  .filter__button-forward {
    @apply block absolute h-full bg-white;
  }
}
</style>
